import React from 'react';

const RS = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_54"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_54)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#0A4981"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10H21V15H0V10Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H21V5H0V0ZM8 10V5H4V10C4 11.105 4.895 12 6 12C7.105 12 8 11.105 8 10Z"
        fill="#CD3E44"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 5L4 4C4 4 5 3 6 3C7 3 8 4 8 4L7 5H5Z"
        fill="#ECBE34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 6L4 7L6 8L5 10L6 12L7 10L6 8L8 7L7 6L6 7L5 6Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 6H4V7L5 6ZM7 6H8V7L7 6Z"
        fill="#ECBE34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 3L5 4L6 5L7 4L6 3Z"
        fill="#A75835"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 8L4 9H8L6 8Z"
        fill="#88605F"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default RS;
